// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605131103/js/" + chunkId + "." + {"44":"b3a4c688","225":"736636d0","481":"37f37954","486":"a9a90f1f","770":"8dd2db89"}[chunkId] + ".0.052965746611912445.chunk.js";
};